"use strict";

import axios from "axios";
import bugsnag from "bugsnag-js";

const BASE_URL = "https://boards-api.greenhouse.io/v1/boards",
  CLIENT_NAME = "ebanx",
  TOKEN = "OGUxZjY2MTk5ZDUzYWFmY2QyYjcyYmNjMWQ1MzBlY2MtMw==",
  PROXY = "https://cors-anywhere.herokuapp.com",
  bugsnagClient = bugsnag("7669486d95f2f10f3ce4db7e97d79b61");

export default {
  namespaced: true,

  state: {
    allOpenings: null,
    allOpeningsByTeam: null,

    hasFetchedAllOpenings: false,

    currentOpeningId: null,
    currentOpeningDetail: null,
    currentOpeningApplicationForm: null,
    hasFetchedOpeningDetails: false,

    hasFetchedApplicationForm: false,
    hasApplicationFormSubmitStarted: false,
    hasApplicationFormSubmitCompleted: false,
    hasApplicationFormSubmitGoneRight: false
  },

  mutations: {
    setAllOpenings(state, payload) {
      state.allOpenings = payload;
    },

    hasFetchedAllOpenings(state, payload) {
      state.hasFetchedAllOpenings = payload;
    },

    setAllOpeningsByTeam(state, payload) {
      state.allOpeningsByTeam = payload;
    },

    setCurrentOpeningId(state, payload) {
      state.currentOpeningId = payload;
    },

    setCurrentOpeningDetail(state, payload) {
      state.currentOpeningDetail = payload;
    },

    setCurrentOpeningApplicationForm(state, payload) {
      state.currentOpeningApplicationForm = payload;
      state.hasFetchedApplicationForm = true;
    },

    hasFetchedOpeningDetails(state, payload) {
      state.hasFetchedOpeningDetails = payload;
    },

    hasApplicationFormSubmitStarted(state, payload) {
      state.hasApplicationFormSubmitStarted = payload;
    },

    hasApplicationFormSubmitCompleted(state, payload) {
      state.hasApplicationFormSubmitCompleted = payload;
    },

    hasApplicationFormSubmitGoneRight(state, payload) {
      state.hasApplicationFormSubmitGoneRight = payload;
    }
  },

  actions: {
    fetchAllOpenings({ commit, dispatch }) {
      return axios
        .get(`${BASE_URL}/${CLIENT_NAME}/jobs?content=true`)
        .then(resp => {
          let objects = resp.data.jobs,
            teams = [],
            openingsByTeam = [];

          const lang = this.getters["language/currentLanguage"];
          let other = "";

          if (lang.includes("pt")) other = "Outro";
          else if (lang.includes("es")) other = "Otro";
          else other = "Other";

          teams = objects.map(opening => {
            let departments;
            for (let team of opening.departments) {
              departments = team.name;
            }

            departments = departments === undefined || departments === null || departments === "" ? other : departments;

            return departments;
          });

          teams = teams.filter((team, pos) => {
            return teams.indexOf(team) === pos;
          });

          for (let team of teams) {
            let openings = [],
              random = Math.random() * (50 - 1) + 1;

            for (let opening of objects) {
              if (!opening.departments[0]) {
                opening.departments[0] = {};
                opening.departments[0].name = other;
              }

              for (let department of opening.departments) {
                if (department.name === team) openings.push(opening);
              }
            }

            openingsByTeam.push({
              id: random,
              team: team,
              count: openings.length,
              openings: openings,
              visible: true
            });
          }

          openingsByTeam.push({
            id: Math.random() * (100 - 51) + 100,
            team: "all",
            count: objects.length,
            openings: objects,
            visible: false
          });

          commit("setAllOpenings", objects);
          dispatch("hasFetchedAllOpenings", true);
          dispatch("allOpeningsByTeam", openingsByTeam);

          return this.getters["openings/allOpenings"];
        })
        .catch(err => {
          console.error(err);

          bugsnagClient.notify(new Error(err), {
            metaData: {
              url: `${BASE_URL}/${CLIENT_NAME}/jobs?content=true`,
              error: err.response
            },
            context: "greenhouse-get-openings-error",
            severity: "error"
          });
        });
    },

    hasFetchedAllOpenings({ commit }, payload) {
      commit("hasFetchedAllOpenings", payload);
    },

    allOpeningsByTeam({ commit }, payload) {
      commit("setAllOpeningsByTeam", payload);
    },

    currentOpeningId({ commit }, payload) {
      commit("setCurrentOpeningId", payload);
    },

    currentOpeningDetail({ commit }, payload) {
      commit("setCurrentOpeningDetail", payload);
    },

    fetchOneOpening({ commit, dispatch }, payload) {
      commit("hasFetchedOpeningDetails", true);

      return axios
        .get(`${BASE_URL}/${CLIENT_NAME}/jobs/${payload}`)
        .then(resp => {
          commit("setCurrentOpeningDetail", resp.data);

          dispatch("currentOpeningId", payload);
          dispatch("fetchOpeningApplicationForm");

          return this.getters["openings/currentOpeningDetail"];
        })
        .catch(err => {
          console.error(err);
          commit("hasFetchedOpeningDetails", false);

          bugsnagClient.notify(new Error(err), {
            metaData: {
              method: "GET",
              url: `${BASE_URL}/${CLIENT_NAME}/jobs/${payload}`,
              error: err.response,
              opening: {
                id: payload
              }
            },
            context: "greenhouse-get-opening-detail-error",
            severity: "error"
          });
        });
    },

    fetchOpeningApplicationForm({ commit }) {
      return axios
        .get(`${BASE_URL}/${CLIENT_NAME}/jobs/${this.getters["openings/currentOpeningId"]}?questions=true`)
        .then(resp => {
          commit("setCurrentOpeningApplicationForm", resp.data);

          return this.getters["openings/currentOpeningApplicationForm"];
        })
        .catch(err => {
          console.error(err);

          commit("setCurrentOpeningApplicationForm", false);

          bugsnagClient.notify(new Error(err), {
            metaData: {
              method: "GET",
              url: `${BASE_URL}/${CLIENT_NAME}/jobs/${this.getters["openings/currentOpeningId"]}?questions=true`,
              info: {
                isLocal: location.href.includes("localhost"),
                opening: {
                  id: this.getters["openings/currentOpeningId"],
                  detail: this.getters["openings/currentOpeningDetail"]
                }
              },
              error: err.response
            },
            context: "greenhouse-get-opening-form-error",
            severity: "error"
          });
        });
    },

    submitApplicationForm({ dispatch }, payload) {
      dispatch("hasApplicationFormSubmitStarted", true);
      let fields = {},
        date = {};
      Object.keys(payload).forEach(key => {
        // get timestamp from masked date
        if (key.includes("date_of_birth")) {
          const split = payload[key].value.split("/");

          payload[key].value = new Date(split[2], parseInt(split[1]) - 1, split[0]).getTime() / 1000;
        }

        // add default facebook url as fallback
        if (key.includes("facebook_") && payload[key].value === "") payload[key].value = "https://facebook.com";

        // add default spanish level as fallback
        if (key.includes("field_key_chg_to_avd_uni_err_1045736") && payload[key].value === "") payload[key].value = "Basico";

        if (payload[key].value.encoded_data && payload[key].value.file_name) {
          fields[key + "_content"] = payload[key].value.encoded_data;
          fields[key + "_content_filename"] = payload[key].value.file_name;
        }

        if (payload[key].value && payload[key].value.encoded_data !== "") {
          fields[key] = payload[key].value;
        } else if (payload[key].value !== "" && typeof payload[key].value !== "object") {
          fields[key] = payload[key].value;
        }
      });
      return axios
        .post(`${PROXY}/${BASE_URL}/${CLIENT_NAME}/jobs/${this.getters["openings/currentOpeningId"]}`, fields, {
          headers: {
            Authorization: `Basic ${TOKEN}`,
            "Content-Type": "application/json"
          }
        })
        .then(resp => {
          dispatch("hasApplicationFormSubmitStarted", false);
          dispatch("hasApplicationFormSubmitCompleted", true);
          dispatch("hasApplicationFormSubmitGoneRight", resp.status === 200);
          return resp;
        })
        .catch(err => {
          dispatch("hasApplicationFormSubmitStarted", false);
          dispatch("hasApplicationFormSubmitCompleted", true);
          bugsnagClient.notify(new Error(err), {
            metaData: {
              url: `${BASE_URL}/${CLIENT_NAME}/jobs/${this.getters["openings/currentOpeningId"]}`,
              method: "POST",
              formData: { fields },
              error: err.response,
              opening: {
                id: this.getters["openings/currentOpeningId"],
                detail: this.getters["openings/currentOpeningDetail"]
              },
              payload: { candidate_age: date }
            },
            context: "greenhouse-application-form-error",
            severity: "error"
          });

          return err;
        });
    },

    hasApplicationFormSubmitStarted({ commit }, payload) {
      commit("hasApplicationFormSubmitStarted", payload);
    },

    hasApplicationFormSubmitCompleted({ commit }, payload) {
      commit("hasApplicationFormSubmitCompleted", payload);
    },

    hasApplicationFormSubmitGoneRight({ commit }, payload) {
      commit("hasApplicationFormSubmitGoneRight", payload);
    }
  },

  getters: {
    allOpenings(state) {
      return state.allOpenings;
    },

    hasFetchedAllOpenings(state) {
      return state.hasFetchedAllOpenings;
    },

    allOpeningsByTeam(state) {
      return state.allOpeningsByTeam;
    },

    currentOpeningId(state) {
      return state.currentOpeningId;
    },

    currentOpeningDetail(state) {
      return state.currentOpeningDetail;
    },

    currentOpeningApplicationForm(state) {
      return state.currentOpeningApplicationForm;
    },

    hasFetchedOpeningDetails(state) {
      return state.hasFetchedOpeningDetails;
    },

    hasFetchedApplicationForm(state) {
      return state.hasFetchedApplicationForm;
    },

    hasApplicationFormSubmitStarted(state) {
      return state.hasApplicationFormSubmitStarted;
    },

    hasApplicationFormSubmitCompleted(state) {
      return state.hasApplicationFormSubmitCompleted;
    },

    hasApplicationFormSubmitGoneRight(state) {
      return state.hasApplicationFormSubmitGoneRight;
    }
  }
};
